// extracted by mini-css-extract-plugin
export default {"cls1":"Reason-cls1__ce713cc59e80967a9b1f","cls2":"Reason-cls2__c98d1bd8753f6a97b4ba Reason-cls1__ce713cc59e80967a9b1f"};